import { useIsMobileApp } from './useIsMobileApp.ts';

export const useCheckForMobilePushNotifications = () => {
  const { isIosApp, isMobileApp, postMessage } = useIsMobileApp();
  if (!isMobileApp) {
    return () => {};
  }
  if (isIosApp) {
    return () => {
      // oxlint-disable-next-line sorare/no-window-location
      window.location.replace('sorare://enable-push-notifications');
    };
  }
  return () => {
    postMessage('enablePushNotifications');
  };
};
